/* @flow */
import { fromJS } from 'immutable';
import { toLower } from 'trustar/utils';

export const REDACTABLE_ENDPOINT = '/services/recommendation/extract';

/* Endpoints for shared library AJAX actions */
// TODO: these are all the same, just export one var...
export const FETCH_LIBRARY_ENDPOINT = '/services/redaction/terms';
export const ADD_ENDPOINT = '/services/redaction/terms'; // -> [ ...terms ] => { savedTerms: [ ...terms ], failedTerms: [ ...terms ] }
export const DELETE_ENDPOINT = '/services/redaction/terms'; // + :id

/* The max number of terms to fetch in a given request.
 * This needs to fixed on the server side, but for now 556 is a magical
 * number that means return all. No limit */
export const FETCH_SIZE = 556;

/* Hardcode list of term categories */
export const categoriesList = [
  { id: 1, name: 'Organization' },
  { id: 2, name: 'Internal Organization' },
  { id: 3, name: 'Partner Organization' },
  { id: 4, name: 'Product' },
  { id: 5, name: 'Company Site' },
  { id: 6, name: 'Company Address' },
  { id: 7, name: 'Location' },
  { id: 8, name: 'Phone' },
  { id: 9, name: 'Person' },
  { id: 10, name: 'Username' },
  { id: 11, name: 'Email Address' },
  { id: 12, name: 'IP Address' },
  { id: 13, name: 'URL' },
  { id: 14, name: 'Domain' },
  { id: 15, name: 'Account Number' },
  { id: 18, name: 'Social Security Number' },
  { id: 19, name: 'Password' },
  { id: 20, name: 'Credit Card' },
  { id: 16, name: 'Other Identifying Info' },
  { id: 17, name: 'Other' },
];

/**
 * Hyphenate a string (and also make it lowercase)
 * Ex: 'Hey there you' -> 'hey-there-you'
 */
export const hyphenate = (str: string) => toLower(str, '').replace(/\s/g, '-');

export const listToOrderedMap = (list: Array<*>) =>
  fromJS(list)
    .toOrderedMap()
    .mapKeys((k, v) => v.get('id'));

export const listToTextMap = (list: Array<*>) =>
  fromJS(list)
    .toMap()
    .mapKeys((k, v) => toLower(v.get('text')));

export const redactionCategories = listToOrderedMap(categoriesList);

/**
 * Get a category by ID. This is currently used to get the name of a category
 * when we only have access to a term. Terms only store the ID of a category so
 * we need a way to get at the name.
 */
export const category = (id: number) => redactionCategories.get(id);

export const categoryByName = (name: string) => redactionCategories.find(x => toLower(x.get('name')) === toLower(name));

export const categoryById = (id: number) => redactionCategories.find(x => x.get('id') === id);

/**
 * Getter for category names in the hyphenated form we use for redaction.
 * Currently we use this for highligting already redacted terms in a text body
 */
export const categoryNames = redactionCategories.map(x => hyphenate(x.get('name'))).toSet();



// WEBPACK FOOTER //
// ./src/app/modules/redaction/constants.js